import { Logging } from './logging';

export class LoggingMock {

    public static logSpy: jasmine.Spy;

    public static mockLog() {
        LoggingMock.logSpy = spyOn(Logging, 'log').and.callFake(<any>MsftSme.noop);
    }
}
